export const locale_en_EN = {};
